import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { CateringPackagesApiRequest, CateringPackagesApiResponse, TransformedCateringPackages } from './types';

// Define a service using a base URL and expected endpoints
// You can import or define the base URL like this:
const baseUrl = process.env.NEXT_PUBLIC_BASE_URL as string;

export const cateringApi = createApi({
  reducerPath: 'cateringApi',
  baseQuery: fetchBaseQuery({ baseUrl: `${baseUrl}` }),
  endpoints: (build) => ({
    getCateringPackages: build.query<TransformedCateringPackages, CateringPackagesApiRequest>({
      query: ({ search, restaurantId }) => {
        const params: Record<string, string | number> = { restaurantId };
        if (search) params.search = search;
        return {
          url: `/v2/${restaurantId}/catering/packages/online`,
          method: 'GET',
          params,
        };
      },
      transformResponse: (data: CateringPackagesApiResponse, meta, arg) => {
        const allPackages = data?.response?.data ?? [];
        const mostPopular: typeof allPackages = [];
        const nonPopular: typeof allPackages = [];
        allPackages.forEach((pkg) => {
          if (pkg.isMostPopular) {
            mostPopular.push(pkg);
          } else {
            nonPopular.push(pkg);
          }
        });
        return {
          mostPopular,
          nonPopular,
          allPackages,
        };
      },
    }),
    inquirePackages: build.mutation<any, { data: any; businessId: string | number }>({
      query: ({ data, businessId }) => ({
        url: `/v2/${businessId}/catering/orders/online`,
        method: 'POST',
        body: data,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
    }),
  }),
});

export const { useGetCateringPackagesQuery, useInquirePackagesMutation } = cateringApi;
